import React, { Component } from 'react'
import { DECORATION, MARKETING } from './constant'
import Style from './style.module.less'
import { Carousel } from 'hljd'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import mainStore from '@components/Main/store'
import { HLJ_STATISTIC, getProTitle } from '@util'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'

@observer
export default class extends Component {
  componentDidMount() {
    HLJ_STATISTIC({
      element_tag: 'no_pro_page_init'
    })
  }

  statisticApp = key => () => {
    HLJ_STATISTIC({
      element_tag: key
    })
  }

  render() {
    const { store } = this.props
    const { merchant_use_list, coupon, pay_money } = store
    const { merchantInfo } = mainStore
    const { property_id } = merchantInfo || {}
    const { coupon_type, gift_day, money_value } = coupon || {}
    const {
      pay_fee, // 支付金额
      fee
    } =
      pay_money || {}

    return (
      <div>
        <div className={Style['shop-open']}>
          <img src="https://qnm.hunliji.com/o_1cvmp6seck9q1m8dlaqlob1unt9.png" />
        </div>
        <div className={Style.decoration}>
          <div className={Style['block-title']}>店铺装修</div>
          <div className={Style['block-desc']}>展示升级，吸引客户关注</div>
          <ul className={Style.decoration}>
            {DECORATION.map((item, index) => {
              if (item.hidden) {
                return undefined
              }

              return (
                <li key={index}>
                  <a
                    style={Style.wrap}
                    href={item.link}
                    onClick={this.statisticApp(item.key)}
                  >
                    <img src={item.img} />
                    <p>{item.title}</p>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        <div className={Style.marketing}>
          <div className={Style.phones}>
            <div className={`${Style.item} ${Style.left}`} />
            <div className={`${Style.item} ${Style.right}`}>
              <div className={`${Style.content} phone-content`}>
                <img src="https://qnm.hunliji.com/o_1cvn52o4119ve1l491a1t1uo81rvfb.png" />
              </div>
            </div>
          </div>

          <div className={Style['block-title']}>营销转化</div>
          <div className={Style['block-desc']}>多功能协同，让你的客源不断</div>

          <ul className={Style['marketing-list']}>
            {MARKETING.map((item, index) => {
              if (property_id != 6 && property_id != 2 && index == 4) {
                return null
              }
              return (
                <li key={index}>
                  <a href={item.link} onClick={this.statisticApp(item.key)}>
                    <img src={item.img} />
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        <div className={Style.channel}>
          <div className={Style['block-title']}>获客拓展</div>
          <div
            className={Style['block-desc']}
            style={{ color: '#000', marginBottom: '48px' }}
          >
            获客拓展 多渠道引流，提升品牌知名度
          </div>
          <div className={Style['channel-block']}>
            <div className={Style['channel-left']}>
              {/* 微传单+ */}
              <a
                href="#/localMerchant/marketingCenter/detail/90"
                onClick={this.statisticApp('no_pro_chanel_detail_90')}
              >
                <img src="https://qnm.hunliji.com/o_1d08shum81ct41iq0ecq11g0ftaj.png" />
              </a>
            </div>
            <div className={Style['channel-right']}>
              <a
                href="#/localMerchant/marketingCenter/selectVersion"
                onClick={this.statisticApp(
                  'no_pro_chanel_detail_select_version'
                )}
              >
                <img
                  className={Style['mb20']}
                  src="https://qnm.hunliji.com/o_1cvngu7g9ehm1q7j1g3il0k9t6b.png"
                />
              </a>
              <a
                href="#/localMerchant/marketingCenter/detail/77"
                onClick={this.statisticApp('no_pro_chanel_detail_77')}
              >
                <img src="https://qnm.hunliji.com/o_1cvnh0jp89me2k7voc1k50c7eo.png" />
              </a>
            </div>
          </div>
        </div>

        <div className={Style.manage}>
          <div className={Style['block-title']}>运营管理</div>
          <div
            className={Style['block-desc']}
            style={{ color: '#000', marginBottom: '12px' }}
          >
            轻松管理线上店铺
          </div>
          <a
            href="#/localMerchant/marketingCenter/detail/74"
            onClick={this.statisticApp('no_pro_manage_detail_74')}
          >
            <img src="https://qnm.hunliji.com/o_1cvnahbqpuvg36918nl16f44s39.png" />
          </a>
        </div>
        {toJS(merchant_use_list) &&
          toJS(merchant_use_list).length > 0 && (
            <div className={Style.other}>
              <div className={Style['block-title']}>
                他们都在用{getProTitle()}
              </div>
              <Carousel autoplay speed={5000} dots={false}>
                {merchant_use_list.map((list, index) => {
                  return (
                    <div className={Style['other-list']} key={index}>
                      {list.map((img, i) => {
                        return <img key={i} src={img.path} />
                      })}
                    </div>
                  )
                })}
              </Carousel>
            </div>
          )}

        <div className={Style.order}>
          <img src="https://qnm.hunliji.com/o_1cvnf31lpsa11f73joae1e7ut.png" />
          <div>
            <div
              className={Style['order-submit']}
              onClick={store.bookService(
                `购买${getProTitle()}`,
                fee,
                'no_pro_bottom'
              )}
            >
              立即订购
            </div>
            <div className={Style['order-phone']}>
              咨询热线 {MERCHANT_CONSULT_PHONE}
            </div>
          </div>
        </div>
        {fee && (
          <div className={Style.footer}>
            <div className={Style.left}>
              服务优惠价：
              <div className={Style['left-price']}>
                <span>￥</span>
                {pay_fee}
              </div>
              /年
              {coupon_type &&
                (coupon_type == 2 ? (
                  <span className={Style['sub-price']}>多送{gift_day}天</span>
                ) : (
                  <span className={Style['sub-price']}>
                    限时减 ￥{money_value}
                  </span>
                ))}
            </div>
            <div className={Style.right}>
              <div
                className={Style['right-submit']}
                onClick={store.bookService(
                  `购买${getProTitle()}`,
                  fee,
                  'no_pro_footer'
                )}
              >
                立即开通
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}
